/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Select, MenuItem, InputLabel, FormControl, InputBase,
} from '@material-ui/core';
import { dropDownStyle, v2DropdownStyles } from '../../css/style';
import withStyles from '@material-ui/core/styles/withStyles';
import DownChevronSelectToggle from './DownChevronSelectToggle';
import * as Constants from '../../data/Constants';
import * as DropdownUtils from '../../utils/DropdownUtils';

const styles = dropDownStyle();

class Dropdown extends Component {
  constructor(props) {
    super(props);
    const {
      data, allowMultiple, allowNone, field, dropdownType,
    } = props;
    let selectedOptions = [];
    if (!data || data.length === 0) {
      selectedOptions = this.getPlaceholderForField();
    } else if (field && ['outOfStock', 'out-of-stock', 'itemOutOfStock'].includes(field.key) && !Array.isArray(data)) {
      this.state = {
        selectedOptions,
        isNoneAllowed: allowNone,
      };
      return;
    } else if (data != null && allowMultiple) {
      selectedOptions = data.map(option => option.id);
    } else if (data != null && (!allowMultiple || allowMultiple === undefined)) {
      dropdownType === 'admin' ? selectedOptions = [data.id] : selectedOptions = data.id;
    }
    this.state = {
      selectedOptions,
      isNoneAllowed: allowNone,
      isOpen: false,
    };
  }

  getPlaceholderForField = () => {
    const { dropdownType, dropdownOptions } = this.props;
    const allLocationOptions = Array.isArray(dropdownOptions) && dropdownOptions.map(option => option.id);
    const finalAllLocationOptions = allLocationOptions ? [...allLocationOptions, DropdownUtils.SELECT_ALL_VALUE] : [DropdownUtils.SELECT_ALL_VALUE];
    return dropdownType === 'locations' ? finalAllLocationOptions : [DropdownUtils.PLACEHOLDER_VALUE];
  }

  componentDidMount = () => {
    const {
      dropdownOptions, dropdownType, actions, apiToken,
    } = this.props;
    if (!dropdownOptions) {
      this.setState({
        selectedOptions: actions.getAllResources(apiToken, dropdownType),
      });
    }
  }

  componentWillReceiveProps = (nextProps) => {
    const {
      data, allowMultiple, dropdownType, allowNone, field, dropdownOptions,
    } = nextProps;

    let selectedOptions = [];
    if (!data && allowNone) {
      selectedOptions = ['none'];
    } else if (!data) {
      selectedOptions = this.getPlaceholderForField();
    } else if (field && field.key === 'locations') {
      this.setSelectedProductLocations(data, dropdownOptions, selectedOptions);
      return;
    } else if (data != null && allowMultiple) {
      if (field && ['outOfStock', 'out-of-stock', 'itemOutOfStock'].includes(field.key) && !Array.isArray(data)) {
        selectedOptions = [];
        this.setState({ selectedOptions });
        return;
      }
      selectedOptions = data.map(option => option.id);
    } else if (data != null && (!allowMultiple || allowMultiple === undefined)) {
      const valueToAssign = dropdownType === 'admin'
        ? [data.id]
        : data.id || (data.target !== undefined ? data.target.value : data);
      selectedOptions = valueToAssign;
    }

    this.setState({ selectedOptions });
  }

  setSelectedProductLocations = (data, dropdownOptions, selectedOptions) => {
    if (!DropdownUtils.allLocationsAreSelected(data, dropdownOptions)) {
      const newSelectedOptions = data.map(option => option.id);
      this.setState({ selectedOptions: newSelectedOptions });
      return;
    }
    const allOptionIds = dropdownOptions.map(option => option.id);
    const newSelectedOptions = [DropdownUtils.SELECT_ALL_VALUE, ...allOptionIds];

    this.setState({ selectedOptions: newSelectedOptions });
  }

  handleAvailableLocationsChange = (event, newSelectedIds) => {
    const { dropdownOptions } = this.props;
    const { selectedOptions: currentSelectedOptions } = this.state;
    let selectedOptions = newSelectedIds.slice();
    if (DropdownUtils.clickedRegularOptionWhileSelectAllIsSelected(newSelectedIds, currentSelectedOptions, dropdownOptions)) {
      selectedOptions = DropdownUtils.removeSelectAllFromSelectedOptions(selectedOptions);
      const fakeEvent = { target: { value: selectedOptions } };
      this.setState({ selectedOptions });
      this.props.onChange(fakeEvent);
      return;
    }

    this.setState({ selectedOptions });
    this.props.onChange(event);
  }

  onChangeSelect = (event) => {
    const { dropdownType } = this.props;
    let newSelectedIds = event.target.value;

    const isAvailableLocationDropdown = dropdownType === 'locations';
    if (isAvailableLocationDropdown) return this.handleAvailableLocationsChange(event, newSelectedIds);
    this.setState({ selectedOptions: newSelectedIds });
    this.props.onChange(event);
  }

  renderOptions = () => (
    this.props.dropdownOptions.map(option => (
      <MenuItem key={option.id} value={option.id} style={this.getDropdownItemStyle(option)} disabled={option.isDisabled}>
        {option.name}
      </MenuItem>
    ))
  )

  getDropdownItemStyle = (option) => {
    if (this.isOrderFilterDropdown()) return styles.v2ToolbarDropdownItem;
    return option.isDisabled ? styles.disabledDropDownItem : styles.dropDownItem;
  }

  placeholderOptionText = () => {
    const { dropdownType, dropdownOptions, placeholder } = this.props;
    const { namePlaceholder, field } = this.props;
    if (dropdownType === 'deliveryOption') return DropdownUtils.PLACEHOLDER_DISPLAY_TITLES.deliveryOption;
    if (dropdownType === 'orderStatus') return DropdownUtils.PLACEHOLDER_DISPLAY_TITLES.orderStatus;
    if (dropdownType === 'admins') return namePlaceholder;

    const isSelectAllField = this.isFieldWithSelectAll(field);
    const selectAllFieldTitle = (field && field.allSelectedDisplayValue)
      || placeholder || DropdownUtils.PLACEHOLDER_DISPLAY_TITLES.defaultSelectAll;
    return Array.isArray(dropdownOptions) && isSelectAllField
      ? selectAllFieldTitle
      : placeholder || DropdownUtils.PLACEHOLDER_DISPLAY_TITLES.pleaseSelect;
  }

  isFieldWithSelectAll = field => field && field.key && Constants.fieldsWithSelectAllOption[field.key]

  renderPlaceholder = () => {
    const {
      dropdownType,
      dropdownOptions,
      field,
      isLocationAdmin,
    } = this.props;

    const value = this.isFieldWithSelectAll(field)
      ? DropdownUtils.SELECT_ALL_VALUE
      : DropdownUtils.PLACEHOLDER_VALUE;

    const isAvailableLocationsDropdownWithNoLocations = dropdownType === 'locations' && Array.isArray(dropdownOptions) && dropdownOptions.length <= 1;
    const disabled = isAvailableLocationsDropdownWithNoLocations || isLocationAdmin;
    return (
      <MenuItem
        value={value}
        style={styles.placeholderOptionText}
        disabled={disabled}
      >
        {this.placeholderOptionText()}
      </MenuItem>
    );
  }

  getClassesObject = () => {
    const { classes, dropdownType } = this.props;
    if (!this.isOrderFilterDropdown()) return;
    return {
      root: classes.root,
      selectMenu: classes.selectMenu,
    };
  }

  toggleSelect = targetState => () => this.setState({ isOpen: targetState })

  maybeDownChevron = () => {
    const { isOpen } = this.state;
    return this.isOrderFilterDropdown() ? DownChevronSelectToggle(this.toggleSelect(!isOpen)) : undefined;
  }

  isOrderFilterDropdown = () => {
    const { dropdownType } = this.props;
    return dropdownType && !!(Constants.orderFiltersDropdownOptions[dropdownType]);
  }

  /**
   * Gets the key for a resource's name, e.g. 'Latte', 'GST', 'Craver Vancouver',
   * whether the options are static, or dynamic and from the database
   */
  getNameLookupKeyForResource = field => (field && field.nameLookupKey) || 'name';

  getSelectAllFieldsDisplayValue = ({
    selectedOptions,
    dropdownOptions,
    nameLookupKey,
    allSelectedDisplayValue,
  }) => {
    if (selectedOptions.length === dropdownOptions.length) return allSelectedDisplayValue;
    return DropdownUtils.getSelectedNameFunctions.array(selectedOptions, nameLookupKey);
  };

  /**
   * Returns the text the dropdown will show while closed
   */
  getDisplayValueText = (newSelectedIds) => {
    const {
      data: parentSelectedOptions,
      field,
      dropdownOptions,
      allowMultiple,
    } = this.props;

    const { selectedOptions: currentSelectedIds } = this.state;

    const isSelectedValueThePlaceholderOption = !allowMultiple && currentSelectedIds[0] === DropdownUtils.PLACEHOLDER_VALUE;
    if (isSelectedValueThePlaceholderOption) return this.placeholderOptionText();

    if (!parentSelectedOptions) return '';
    const nameLookupKey = this.getNameLookupKeyForResource(field);
    if (this.isFieldWithSelectAll(field)) {
      let { allSelectedDisplayValue } = field;
      if (!allSelectedDisplayValue && (field.key === 'outOfStock' || field.key === 'locations')) {
        allSelectedDisplayValue = 'All Locations';
      }
      const getDisplayValueArgs = {
        selectedOptions: parentSelectedOptions,
        dropdownOptions,
        nameLookupKey,
        allSelectedDisplayValue,
      };
      return this.getSelectAllFieldsDisplayValue(getDisplayValueArgs);
    }
    const isArrayOrOther = Array.isArray(parentSelectedOptions) ? 'array' : 'other';
    return DropdownUtils.getSelectedNameFunctions[isArrayOrOther](parentSelectedOptions, nameLookupKey);
  }

  getDisplayValue = (newSelectedIds) => {
    const { dropdownType, field } = this.props;
    const text = dropdownType === 'locations' && Array.isArray(newSelectedIds) && (newSelectedIds.includes(DropdownUtils.SELECT_ALL_VALUE) || newSelectedIds.length === 0)
      ? field && field.allSelectedDisplayValue
      : this.getDisplayValueText(newSelectedIds);
    return (
      <div style={styles.displayValueText}>{text}</div>
    );
  }

  render() {
    const {
      loading, dropdownOptions, allowMultiple, label, style, disabled, dropdownType,
    } = this.props;
    const { isOpen } = this.state;
    const selectedOptions = this.state.selectedOptions || [];
    const formControlStyle = this.isOrderFilterDropdown() ? styles.noMarginFormControlStyle : styles.formControlStyle;

    return (
      (loading)
        ? <div>Loading...</div>
        : (!dropdownOptions)
          ? <div />
          : (
            <React.Fragment>
              <FormControl style={formControlStyle} margin="normal">
                <InputLabel htmlFor="select-multiple">{label}</InputLabel>
                <Select
                  open={isOpen}
                  onOpen={this.toggleSelect(true)}
                  onClose={this.toggleSelect(false)}
                  multiple={allowMultiple}
                  value={selectedOptions}
                  onChange={event => this.onChangeSelect(event)}
                  style={style}
                  input={<InputBase />}
                  disabled={disabled}
                  classes={this.getClassesObject()}
                  IconComponent={this.maybeDownChevron()}
                  renderValue={this.getDisplayValue}
                >
                  {dropdownType !== 'admins' && this.renderPlaceholder()}
                  {
                    this.state.isNoneAllowed && <MenuItem value="none" style={styles.placeholderOptionText}>None</MenuItem>
                  }
                  {this.renderOptions()}
                </Select>
              </FormControl>
              <div style={styles.orderStatusFilterRightSpacer} />
            </React.Fragment>
          )
    );
  }
}

Dropdown.propTypes = {
  data: PropTypes.any,
  actions: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  allowMultiple: PropTypes.bool,
  dropdownOptions: PropTypes.array,
  dropdownType: PropTypes.string,
  field: PropTypes.string,
  placeholder: PropTypes.string,
};

Dropdown.defaultProps = {
  data: null,
  allowMultiple: null,
  loading: null,
  dropdownOptions: null,
  dropdownType: null,
  field: null,
  placeholder: null,
};

export default withStyles(v2DropdownStyles)(Dropdown);
